import React from 'react';

import { graphql, withApollo } from 'react-apollo';
import Loading from '../../common/Loading';
import _ from 'lodash';

import getOrganismos from '../../../graphql/querys/organismos/getOrganismos.graphql';

import TablaOrganismos from './TablaOrganismos';

@graphql(getOrganismos, { options: { fetchPolicy: 'network-only' } })
class VerOrganismos extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      filtro: '',
      currentPage: 1,
      listaTotal: [],
      lista: [],
      primeraCarga: true,
    };
  }

  _executeSearch = async () => {
    //Esta funcion es la encargada de re-llamar al servidor para traer las notas filtradas.

    this.setState({
      ...this.state,
      loading: true,
    });

    let listaFiltrada = _.filter(this.props.data.getOrganismos, usuario => {
      return (
        usuario.nombre.toUpperCase().indexOf(this.state.filtro.toUpperCase()) >
          -1 ||
        usuario.apellido
          .toUpperCase()
          .indexOf(this.state.filtro.toUpperCase()) > -1 ||
        usuario.username
          .toUpperCase()
          .indexOf(this.state.filtro.toUpperCase()) > -1
      );
    });

    this.setState(
      {
        ...this.state,
        loading: false,
        listaTotal: listaFiltrada,
      },
      function() {
        this.ordenarLista(1, 10);
      }
    );
  };

  filtrarPorNombre = async filtro => {
    //Esta funcion es la encargada de re-llamar al servidor para traer las notas filtradas.

    this.setState({
      ...this.state,
      loading: true,
    });

    let listaFiltrada = _.filter(this.props.data.getOrganismos, organismo => {
      return organismo.nombre.toUpperCase().indexOf(filtro.toUpperCase()) > -1;
    });

    this.setState(
      {
        ...this.state,
        loading: false,
        listaTotal: listaFiltrada,
      },
      function() {
        this.ordenarLista(1, 10);
      }
    );
  };

  filtrarPorCircunscripcion = async filtro => {
    //Esta funcion es la encargada de re-llamar al servidor para traer las notas filtradas.

    this.setState({
      ...this.state,
      loading: true,
    });

    let listaFiltrada = _.filter(this.props.data.getOrganismos, organismo => {
      if (!organismo.circunscripcion) {
        return false;
      }
      return (
        organismo.circunscripcion.toUpperCase().indexOf(filtro.toUpperCase()) >
        -1
      );
    });

    this.setState(
      {
        ...this.state,
        loading: false,
        listaTotal: listaFiltrada,
      },
      function() {
        this.ordenarLista(1, 10);
      }
    );
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.data.getOrganismos) {
      this.setState(
        {
          ...this.state,
          listaTotal: nextProps.data.getOrganismos,
        },
        function() {
          this.ordenarLista(1, 10);
        }
      );
    }
  }

  ordenarLista = (numPagina, tamPagina) => {
    let listaOrdenada = _.orderBy(
      this.state.listaTotal,
      [
        organismo => {
          return organismo.nombre.toUpperCase();
        },
      ],
      ['asc']
    );

    let listaCorta = _.slice(
      listaOrdenada,
      0 + (numPagina - 1) * tamPagina,
      tamPagina * numPagina
    );

    this.setState({
      ...this.state,
      currentPage: numPagina,
      lista: listaCorta,
    });
  };

  render() {
    if (this.state.loading) {
      return <Loading />;
    }

    const pagination = {
      pageSize: 10,
      current: this.state.currentPage,
      total: this.state.listaTotal ? this.state.listaTotal.length : 0,
      onChange: (page, pageSize) => {
        this.ordenarLista(page, pageSize);
      },
    };

    return (
      <div>
        <TablaOrganismos
          organismos={this.state.lista}
          history={this.props.history}
          onDelete={this.onDelete}
          pagination={pagination}
          filtrarPorNombre={this.filtrarPorNombre}
          filtrarPorCircunscripcion={this.filtrarPorCircunscripcion}
          usuario={this.props.usuario}
        />
      </div>
    );
  }
}

export default withApollo(VerOrganismos);
